import React from 'react'
import { t } from 'ttag'

import { useTitleChange } from '../../util/hooks'

const ProfileCreationConfirmationContainer = () => {
  useTitleChange(t`Thank You`)

  return (
    <div className="container">
      <div>
        {t`Thank you for your submission.`}
        {t`The primary contact that you provided will receive a follow up call or email soon.`}
      </div>
    </div>
  )
}

export default ProfileCreationConfirmationContainer
